import store from "../redux/store";
import Cookies from "universal-cookie";
import { I18nManager, Platform } from "react-native";
const cookies = new Cookies();

function translate(text) {
  const rtl = store.getState().main.rtl;
  const persian = {
    welcome: "عزیز، خوش آمدید",
    user: "کاربر",
    ChildrenNotComplete: "شما هنوز  فرزندی را اضافه نکرده اید.",
    completeInfo: "تکمیل اطلاعات",
    noChildYet: "شما هنوز فرزندی اضافه نکرده اید",
    wallet: "کیف پول",
    "login first": "",
    "your balance": "موجودی شما",
    currency: "تومان",
    "charge wallet": "افزایش موجودی",
    "number of participant": "نفر شرکت کننده",
    test: "آزمون",
    "ASQSE2 test": "آزمـــــون ASQSE2",
    "ASQ3 test": "آزمـــــون ASQ3",
    "ADHD test": "آزمـــــون ADHD",
    growth: "رشــــد",

    "grow test": "آزمـــــــون رشد",
    from: "از",
    "test you have done": "آزمون را انجام داده اید",
    tutorials: "آموزش ها",
    details: "جزئیات",
    profile: "پروفایل",
    support: "پشتیبانی",
    about: "درباره ما",
    logout: "خروج از حساب",
    "app language": "زبان برنامه",
    login: "ورود به حساب",
    signup: "ایجاد حساب",
    "you are not logged in": "شما هنوز وارد حساب خود نشده اید !",
    "phone number or email": "شماره همراه",
    "login to account": "ورود به حساب کاربری",
    "get code": "دریافت کد",
    "resend in": "ارسال مجدد در",
    seconds: "ثانیه",
    "resend code": "ارسال مجدد",
    edit: "ویرایش",
    "verify code sent to": "کد تایید به شماره",
    "sent persian only": "ارسال شد",
    home: "خانه",
    history: "سوابق",
    doctors: "مشاوره",
    learn: "آموزش",
    "consultation and help": "مشاوره و راهنمایی",
    "your son": "پسر شما",
    "your daughter": "دختر شما",
    "has #only english": "",
    "years old": "سال سن دارد",
    "choose another children": "انتخاب فرزند دیگر",
    "choose doctor for": "انتخاب مشاور برای",
    close: "بستن",
    "search by name": "جستجو بر اساس نام",
    specialties: "تخصص",
    "number of followers": "تعداد مشاوره گیرندگان",
    "request for consultation": "درخواست مشاوره",
    "for each consultation": "به ازای هر مشاوره",
    pay: "پرداخت",
    "no money #full text":
      "متاسفانه موجودی کیف پول شما برای پرداخت هزینه ی مشاوره کافی نیست !",
    "add children": "افزودن فرزند",
    "tutorials of parents": "آموزش برای والدین",
    tutorial: "آموزش",
    ages: "رده سنی",
    years: "سال",
    writer: "ناشر",
    "tutorial video": "ویدیو آموزش",
    "what is your feedback ?": "بازخورد شما چیست ؟",
    "i liked it": "دوست داشتم",
    "i didn't liked it": "دوست نداشتم",
    "tests and history": "آزمــون و سوابق",
    "cost of test": "هزینه ی آزمون",
    "start test": "ثبت نام در آزمون",
    "test age": "دوره سنی آزمون",
    "test participated date": "تاریخ انجام آزمون",
    "not participated": "انجام نشده",
    "do test": "انجام آزمون",
    "answered questions": "تعداد سوالات پاسخ داده شده",
    question: "سوال",
    "test result": "نتیجه آزمون",
    "description video": "ویدیو توضیحات",
    part: "قسمت",
    "number of questions": "تعداد سوالات آزمون",
    "charge balance": "افزایش موجودی",
    transactions: "تراکنش ها",
    "enter money amount": "مبلغ مورد نظر را به ریال وارد کنید",
    "user details (parent)": "مشخصات کاربر (والد)",
    "I'm mother": "مادر هستم",
    "I'm father": "پدر هستم",
    name: "نام",
    "last name": "نام خانوادگی",
    "national code": "کد ملی",
    "refer id": "کد معرف",
    "current address (optional)": "محل سکونت (اختیاری)",
    province: "استان",
    city: "شهر",
    submit: "ذخیره",
    "add new child": "افزودن فرزند",
    "please choose your child gender": "لطفاً جنسیت فرزند خود را انتخاب نمایید",
    "your daughter name": "نام دختر شما",
    "your daughter last name": "نام خانوادگی دختر شما",
    "your daughter birth date": "تاریخ تولد دختر شما",
    "pregnancy due date": "مدت زمان بارداری",
    "upload child image": "آپلود عکس فرزند",
    "your son name": "نام پسر شما",
    "your son last name": "نام خانوادگی پسر شما",
    "your son birth date": "تاریخ تولد پسر شما",
    month: "ماه",
    day: "روز",
    year: "سال",
    week: "هفته",
    boy: "پسر",
    girl: "دختر",
    add: "افزودن",
    "Dear parent, please answer the questions accurately and correctly.":
      "والد گرامی لطفاً به سوالات به صورت دقیق و درست پاسخ دهید.",
    "Your honest and accurate answers will make the result of the test more correct and accurate.":
      "پاسخ های صادقانه و دقیق شما باعث میشود نتیجه ی بدست آمده از آزمون درست تر و دقیق تر باشد.",
    "If you are confused about a question, there is a video or text to explain the question for most of the questions.":
      "در صورتی که برای سوالی دچار ابهام شدید برای اکثر سوالات ویدیو و یا متنی برای توضیح صورت سوال وجود دارد.",
    "start doing test": "شروع آزمون",
    "previous question": "سوال قبل",
    "text explain": "توضیح کامل سوال",
    "video explain": "ویدیو توضیح سوال",
    "next question": "سوال بعد",
    "skip question": "رد شدن از سوال",
    "got it": "متوجه شدم",
    email: "ایمیل",
    "children birth order": "فرزند چندم ؟",

    "there is no item": "موردی یافت نشد",
    monthy: "ماهگی",
    "not completed": "کامل نشده",
    Growth: "رشد",
    "please login first": "لطفاً ابتدا وارد حساب کاربری خود شوید",
    "We are sorry, This item isn't available for now !":
      "متاسفیم ! این قابلیت هنوز فعال نشده",
    "next step": "مرحله بعد",
    communication: "ارتباطات",
    General: "عمومی",
    problemSolving: "حل مسئله",
    fineMovements: "حرکات ظریف",
    grossMovements: "حرکات درشت",
    PersonalSocial: "شخصي-اجتماعي",
    "test review": "مرور آزمون",
    "you can edit questions by touching them":
      "** با لمس کردن هر سوال میتوانید پاسخ خود را ویرایش کنید",
    answer: "پاسخ",
    "no answer to this question": "شما به این سوال پاسخ نداده اید",
    "submit answers and see result": "اتمام آزمون و دیدن نتیجه",
    "please wait": "لطفاً کمی صبر کنید",
    "preparing test result": "در حال آماده سازی نتیجه آزمون",
    "your child": "فرزند شما",
    Percentiles5: "صدک 5",
    Percentiles25: "صدک 25",
    Percentiles50: "صدک 50",
    Percentiles75: "صدک 75",
    Percentiles95: "صدک 95",
    "please enter you child height in centimeters":
      "لطفاً قد کنونی فرزند خود را به سانتی متر وارد کنید",
    "please enter you child weight": "لطفاً وزن کنونی فرزند خود را وارد کنید",
    "please enter you child head size in centimeters":
      "لطفاً اندازه دور سر کنونی فرزند خود را به سانتی متر وارد کنید",
    kilograms: "کیلوگرم",
    grams: "گرم",
    "you didn't added any children": "شما هنوز فززندی اضافه نکرده اید",
    "online support": "پشتیبانی آنلاین",
    "common questions": "سوالات متداول",
    minutes: "دقیقه",
    "there is no tests": "آزمون قابل نمایشی وجود ندارد",
    notifications: "اعلان ها",
    "payment service select": "انتخاب سرویس پرداخت",
    "about us": "درباره ما",
    send: "ارسال",
    sending: "در حال ارسال",
    "connection error": "خطای ارتباط با سرور",
    "your child birth weight": "وزن فرند هنگام تولد",
    "your child birth height": "قد فرزند هنگام تولد",
    cm: "سانتی متر",
    "my children": "فرزندان من",
    "save changes": "ذخیره تغییرات",
    "changes successfully saved": "تغییرات با موفقیت ذخیره شد",
    "edit information": "ویرایش مشخصات",
    "how to use this app": "نحوه استفاده از برنامه",
    "rotate for full size chart":
      "برای مشاهده بهتر چارت دستگاه خود را در حالت افقی قرار دهید",
    "full size chart": "نمایش بصورت تمام صفحه",
    "exit full size chart": "خروج از حالت تمام صفحه",
    strengths: "نقاط قوت",
    weaknesses: "نقاط ضعف",
    description: "توضیحات",
    "submit rate": "ثبت بازخورد",
    "delete child": "حذف فرزند",
    remaining: "باقی مانده",
    "its not possible to skip": "امکان رد شدن وجود ندارد",
    "for answers first answer all sections":
      "برای دیدن نتایج ابتدا باید همه بخش ها را پاسخ دهید",
    "test archive": "آرشیو آزمون ها",
    "update required #full text":
      "برای استفاده از برنامه لطفا ابتدا نسخه ی جدید را دانلود و نصب نمایید",
    "Download App": "دانلود برنامه",
    "Premature birth": "تولد زود تر از موعد",
    and: "و",
    "your child age": "سن فرزند شما :",
    free: "رایگان",
    bought: "خریداری شده",
    cancel: "لغو",
    accept: "تائید",
    file: "فایل",
    video: "فیلم",
    "Tutorial Documents": "مستندات آموزش",
    "buy tutorial": "خرید آموزش",
    "first you need to buy this tutorial for full access":
      "ابتدا باید این آموزش را خریداری کنید",
    "with confirming": "با تایید خرید مبلغ",
    "will be deducted from your wallet": "تومان از حساب شما کسر خواهد شد",
    "consultation request is full": "عدم وجود ظرفیت",
    "download chart image": "دانلود تصویر چارت",
    "saved successfully": "با موفقیت در گالری ذخیره شد",
  };

  //thi is seperator fot this two languagues
  //thi is seperator fot this two languagues
  //thi is seperator fot this two languagues
  //thi is seperator fot this two languagues
  //thi is seperator fot this two languagues
  //thi is seperator fot this two languagues
  //thi is seperator fot this two languagues
  //thi is seperator fot this two languagues
  //thi is seperator fot this two languagues
  //thi is seperator fot this two languagues
  //thi is seperator fot this two languagues
  //thi is seperator fot this two languagues

  const english = {
    welcome: "Welcome ! ",
    user: "User",
    ChildrenNotComplete: "Your didn't add any child yet.",
    completeInfo: "Edit information",
    noChildYet: "There is no child yet",
    wallet: "My Wallet",
    "your balance": "Your Balance",
    currency: "$",
    "charge wallet": "Buy",
    "number of participant": "Number of Participant",
    "grow test": "Grow Test",
    test: "test",
    from: "from",
    "test you have done": "tests has been completed",
    tutorials: "Tutorials",
    details: "Details",
    profile: "profile",
    support: "Support",
    about: "About Us",
    logout: "Logout",
    "app language": "App Language",
    login: "Login",
    signup: "Signup",
    "you are not logged in": "You are not logged in to your account !",
    "phone number or email": "Email address",
    "login to account": "Login to Account",
    "get code": "Get Code",
    "resend in": "Resend in",
    seconds: "seconds",
    "resend code": "Resend code",
    edit: "Edit",
    "verify code sent to": "Verify code sent to",
    "sent persian only": "",
    home: "Home",
    history: "History",
    doctors: "Doctors",
    learn: "Learn",
    "consultation and help": "Consultation And Help",
    "your son": "Your son",
    "your daughter": "Your daughter",
    "has #only english": " has ",
    "years old": "years old",
    "choose another children": "Choose another children",
    "choose doctor for": "Choose doctor for",
    close: "close",
    "search by name": "Search by name",
    specialties: "Specialties",
    "number of followers": "followers",
    "request for consultation": "Request",
    "for each consultation": "for each consultation",
    pay: "pay",
    "no money #full text":
      "Unfortunately your account balance is not enough for paying !",
    "add children": "Add new children",
    "tutorials of parents": "Tutorials of parents",
    tutorial: "Tutorial",
    ages: "Ages",
    years: "Years",
    writer: "writer",
    "tutorial video": "Tutorial video",
    "what is your feedback ?": "What is your feedback ?",
    "i liked it": "Like",
    "i didn't liked it": "Unlike",
    "tests and history": "Tests and history",
    "cost of test": "cost of test",
    "start test": "Start test",
    "test age": "Test age",
    "test participated date": "Test participated date",
    "not participated": "Not participated",
    "do test": "Start Test",
    "answered questions": "answered questions",
    question: "questions",
    "test result": "Test result",
    "description video": "description video",
    part: "Part",
    "number of questions": "number of questions",
    "charge balance": "Charge balance",
    transactions: "transactions",
    "enter money amount": "Please enter money amount",
    "user details (parent)": "User details (parent)",
    "I'm mother": "I'm mother",
    "I'm father": "I'm father",
    name: "name",
    "last name": "last natme",
    "national code": "national code",
    "refer id": "refer id",
    "current address (optional)": "current address (optional)",
    province: "province",
    city: "city",
    submit: "submit",
    "add new child": "Add child",
    "please choose your child gender": "please choose your child gender",
    "your daughter name": "your daughter name",
    "your daughter last name": "your daughter last name",
    "your daughter birth date": "your daughter birth date",
    "pregnancy due date": "pregnancy due date",
    "upload child image": "upload child image",
    "your son name": "your son name",
    "your son last name": "your son last name",
    "your son birth date": "your son birth date",
    month: "month",
    day: "day",
    year: "year",
    week: "week",
    boy: "boy",
    girl: "girl",
    add: "Save",
    "Dear parent, please answer the questions accurately and correctly.":
      "Dear parent, please answer the questions accurately and correctly.",
    "Your honest and accurate answers will make the result of the test more correct and accurate.":
      "Your honest and accurate answers will make the result of the test more correct and accurate.",
    "If you are confused about a question, there is a video or text to explain the question for most of the questions.":
      "If you are confused about a question, there is a video or text to explain the question for most of the questions.",
    "start doing test": "Start Test",
    "previous question": "previous question",
    "text explain": "text explain",
    "video explain": "video explain",
    "next question": "continue",
    "skip question": "skip question",
    "got it": "got it",
    email: "email",
    "children birth order": "children birth order",
    "there is no item": "There is no item",
    monthy: "months",
    "not completed": "not completed",
    "please login first": "Please log in to your account first",
    "We are sorry, This item isn't available for now !":
      "We are sorry, This item isn't available for now !",
    "next step": "next step",
    communication: "communication",
    General: "general",
    problemSolving: "problem solving",
    fineMovements: "fine movements",
    grossMovements: "gross movements",
    PersonalSocial: "personal and social",
    "test review": "Test review",
    "you can edit questions by touching them":
      "You can edit questions by touching them",
    answer: "answer",
    "no answer to this question": "no answer to this question",
    "submit answers and see result": "Submit answers and see result",
    "please wait": "Please wait",
    "preparing test result": "preparing test result",
    "your child": "your child",
    Percentiles5: "percentile 5",
    Percentiles25: "percentile 25",
    Percentiles50: "percentile 50",
    Percentiles75: "percentile 75",
    Percentiles95: "percentile 95",
    "please enter you child height in centimeters":
      "please enter you child height in centimeters",
    "please enter you child weight": "please enter you child weight",
    "please enter you child head size in centimeters":
      "please enter you child head size in centimeters",
    kilograms: "kilograms",
    grams: "grams",
    "you didn't added any children": "you didn't added any children",
    "ASQSE2 test": "ASQSE2 Test",
    "ASQ3 test": "ASQ3 Test",
    "ADHD test": "ADHD Test",
    growth: "Growth",
    "online support": "online support",
    "common questions": "common questions",
    minutes: "minutes",
    "there is no tests": "there is no tests",
    notifications: "notifications",
    "payment service select": "payment service select",
    "about us": "About Us",
    send: "send",
    sending: "sending",
    "connection error": "Connection Error",
    "your child birth weight": "your child birth weight",
    "your child birth height": "your child birth height",
    cm: "cm",
    "my children": "my children",
    "save changes": "save changes",
    "changes successfully saved": "changes successfully saved",
    "edit information": "edit information of ",
    "how to use this app": "how to use this app",
    "rotate for full size chart": "rotate your device for full size chart",
    "full size chart": "full size chart",
    "exit full size chart": "exit full size chart",
    strengths: "strengths",
    weaknesses: "weaknesses",
    description: "weaknesses",
    "submit rate": "submit rate",
    "delete child": "Delete Child",
    remaining: "remaining",
    "its not possible to skip": "Can't skip more than two questions",
    "for answers first answer all sections":
      "for answers first answer all sections",
    "test archive": "test archive",
    "update required #full text":
      "Update required for using App. Please Download and Install new Version",
    "Download App": "Download App",
    "Premature birth": "Premature birth",
    and: "and",
    "your child age": "Your child age",
    free: "Free",
    bought: "Owned",
    cancel: "Cancel",
    accept: "Accept",
    file: "File",
    video: "Video",
    "Tutorial Documents": "Tutorial Documents",
    "buy tutorial": "Buy Tutorial",
    "first you need to buy this tutorial for full access":
      "first you need to buy this tutorial for full access",
    "with confirming": "with confirming",
    "$ will be deducted from your wallet": "will be deducted from your wallet",
    "consultation request is full": "consultation request is full",
    "download chart image": "download chart image",
    "saved successfully": "saved successfully",
  };

  if (rtl) {
    return persian[text];
  } else {
    return english[text];
  }
}
export default translate;
function descriptionTranslate(description) {
  const rtl = store.getState().main.rtl;
  if (rtl) {
    return description.fa;
  } else {
    return description.en;
  }
}
export { descriptionTranslate };
